import { useEffect } from 'react';
import { setupGlobalErrorHandlers, trackNavigation } from '@/lib/errorLogger';
import { useLocation } from 'react-router-dom';

/**
 * Hook to initialize error logging and track navigation
 */
export function useErrorLogger() {
  const location = useLocation();

  // Set up global error handlers once on mount
  useEffect(() => {
    setupGlobalErrorHandlers();
  }, []);

  // Track navigation changes
  useEffect(() => {
    trackNavigation(location.pathname);
  }, [location.pathname]);
}
